<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="类型 0-外部链接" prop="type" >-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('user.disposition.title')" prop="titleIn" >
        <a-input v-model="form.titleIn" :placeholder="$t('user.disposition.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.titleEn')" prop="titleEn" >
        <a-input v-model="form.titleEn" :placeholder="$t('user.disposition.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.titleCn')" prop="titleCn" >
        <a-input v-model="form.titleCn" :placeholder="$t('user.disposition.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('system.titleArabic')" prop="title" >
        <a-input v-model="form.title" :placeholder="$t('user.disposition.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
<!--      <a-form-model-item label="西班牙语语标题" prop="titleBm" >-->
<!--        <a-input v-model="form.titleBm" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('user.disposition.content')" prop="contentIn" >
<!--        <editor v-model="form.content" />-->
        <a-input v-model="form.contentIn" :placeholder="$t('user.disposition.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('user.disposition.content') + '(' + $t('system.titleEn') + ')'" prop="contentEn" >
        <a-input v-model="form.contentEn" :placeholder="$t('user.disposition.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('user.disposition.content') + '(' + $t('system.titleCn') + ')'" prop="contentCn" >
        <a-input v-model="form.contentCn" :placeholder="$t('user.disposition.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('user.disposition.content') + '(' + $t('system.titleArabic') + ')'" prop="content" >
        <a-input v-model="form.content" :placeholder="$t('user.disposition.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
<!--      <a-form-model-item label="西班牙语语内容" prop="contentBm" >-->
<!--        <a-input v-model="form.contentBm" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="是否启用" prop="isOpen" >-->
<!--        <a-input v-model="form.isOpen" placeholder="请输入是否启用" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="排序" prop="sort" >-->
<!--        <a-input v-model="form.sort" placeholder="请输入排序" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDisposition, addDisposition, updateDisposition } from '@/api/user/disposition'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: 0,

        title: null,

        titleEn: null,

        titleCn: null,

        titleBm: null,

        titleIn: null,

        content: null,

        contentEn: null,

        contentCn: null,

        contentBm: null,

        contentIn: null,

        isOpen: 1,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        content: [
          { required: true, message: this.$t('user.disposition.arabicContentRequired'), trigger: 'blur' }
        ],
        isOpen: [
          { required: true, message: this.$t('user.disposition.isOpenRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: 0,
        title: null,
        titleEn: null,
        titleCn: null,
        titleBm: null,
        titleIn: null,
        content: null,
        contentEn: null,
        contentCn: null,
        contentBm: null,
        contentIn: null,
        isOpen: 1,
        sort: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDisposition({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDisposition(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDisposition(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
